import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsSpinalStenosisCPR extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_SpinalStenosisCPR' name='Spinal Stenosis CPR' visible={false} flagged={this.props.flagged}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Spinal Stenosis CPR' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSSCBILAT === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSSCLEGGTBACK === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSSCPAINWALK === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSSCPAINRELIEF === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSSCAGEGT48) {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'SpinalStenosisCPR'),
        flagged: flagCount >= 4 ? true : false
    };
}

const connectedSpecTestsSpinalStenosisCPR = connect(mapStateToProps)(SpecTestsSpinalStenosisCPR);
export { connectedSpecTestsSpinalStenosisCPR as SpecTestsSpinalStenosisCPR };
